module.exports = __webpack_public_path__ + "img/buffalo.24436ddc.png";